
































































































import Vue from "vue";
import CustomTable from "@/components/Table/table.vue";
import CustomCheckbox from "@/components/Input/Checkbox.vue";
import { DataTableHeader } from "vuetify/types";
import router from "@/router/router";
import { store } from "@/store/store";

interface DeviceTableData {
  headers: Array<DataTableHeader>;
}

export default Vue.extend({
  name: "DeviceTable",
  components: { CustomTable, CustomCheckbox },
  props: {
    selected: {
      type: Array as () => Array<string>
    },
    shouldDisplayDescriptionPanel: {
      type: Function
    },
    onSelectChange: {
      type: Function
    },
    searchFilter: {
      type: Object
    },
    customFilter: {
      type: Function
    },
    formattedData: {
      type: Array
    },
    currentItems: {
      type: Function
    },
    selectedToggleAll: {
      type: Function
    },
    selectedChange: {
      type: Function
    },
    sortBy: {
      type: String,
      default: undefined
    },
    sortDesc: {
      type: Boolean,
      default: undefined
    },
    defaultItemPerPage: {
      type: Number,
      default: 10
    },
    pagination: {
      type: Function,
      default: () => undefined
    }
  },
  data: (): DeviceTableData => {
    return {
      headers: [
        { text: "", value: "selected", sortable: false },
        { text: "Êtat", value: "state", align: "center" },
        { text: "Nom", align: "start", value: "material_name" },
        { text: "Campagne", align: "start", value: "campaign" },
        { text: "Poste", align: "start", value: "poste" },
        { text: "Catégorie", align: "start", value: "category" },
        { text: "Agence", value: "agence" },
        { text: "Mis à jour", value: "updated" },
        { text: "actions", value: "actions", sortable: false, width: "10%", align: "center" }
      ]
    };
  },
  methods: {
    shouldDisplayModifyModal(device_id: string): void {
      this.$emit("shouldDisplayModifyModal", device_id);
    },
    shouldDisplayDeleteModal(device_id: string): void {
      this.$emit("shouldDisplayDeleteModal", device_id);
    },
    shouldDisplayAssignationModal(device_id: string): void {
      this.$emit("shouldDisplayAssignationModal", device_id);
    },
    defineStateColor(id: string): string {
      return store.getters.STATE_BY_ID[store.getters.DEVICE_BY_ID[id].state].color;
    },
    CheckIfSelected(_id: string): boolean {
      return this.selected.findIndex((selected_item) => selected_item === _id) !== -1;
    },
    redirectToDevicePage(item: any): void {
      router.push({ path: `/device?deviceId=${item._id}` });
    },
    shouldDisplayAssignationButton(device_id: string): boolean {
      return store.getters.STATE_BY_ID[store.getters.DEVICE_BY_ID[device_id].state].name === "Réserve - Disponible";
    }
  }
});
